<template>
  <div style="height: 100%">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welfarelist' }"
        >返回</el-breadcrumb-item
      >
      <el-breadcrumb-item>福利发放</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="welfare-main">
      <div class="top-menu">
        <div class="name-value">
          已选择<span>{{ matesCount }}人</span> 福利发放总金额（元）：<span>{{
            allMoney ? allMoney : "0.00"
          }}</span>
        </div>
        <el-button type="success" class="btn" @click="welVisible = true"
          >添加福利人员</el-button
        >
        <el-button
          type="primary"
          class="btn"
          @click="ensureVisible = true"
          :disabled="submitMates.length <= 0"
          >提交申请</el-button
        >
      </div>
      <div class="welfare-bottom">
        <!--  -->
        <el-card
          class="wel-item"
          v-for="(mates, index) in submitMates"
          :key="index"
        >
          <div class="head-container">
            <div class="mate" v-for="i in mates" :key="i.userId">
              <i class="el-icon-error" @click="removeMate(i, index)"></i>
              <span class="newAdd" v-show="i.isNew">新</span>
              <span class="d4" v-show="i.isNew"></span>
              <div class="avatar">{{ i.realname.substring(0, 1) }}</div>
              <div class="name-money">
                <div class="name">{{ i.realname }}</div>
                <div class="money">{{ i.amount | number }}</div>
              </div>
            </div>
          </div>
          <div class="tip">备注：{{ mates[0].desc }}</div>
        </el-card>

        <div class="empty-view" v-if="submitMates.length <= 0">
          <img src="../../assets/empty.png" />
          <p>选择人员发放福利吧</p>
        </div>
      </div>
    </div>

    <el-dialog
      title="确定提交本次福利发放申请？"
      :visible.sync="ensureVisible"
      width="30%"
    >
      <span> 提交福利发放申请后，将由福利审核人进行审核 </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ensureVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="walfareClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 由于未知的原因，这个dialog里的css样式都不起作用，所以样式就直接写在html元素的style属性里了 -->
    <el-dialog title="福利设置" :visible.sync="welVisible" width="40%">
      <div>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 20px;
          "
        >
          <el-input
            style="width: 50%; margin-left: 10px"
            placeholder="搜索员工"
            prefix-icon="el-icon-search"
            v-model="searchStr"
          ></el-input>
          <el-select
            style="margin-left: 10px"
            v-model="value"
            @change="searchList"
          >
            <el-option label="全部部门" value="全部部门"></el-option>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              >{{ item.name }}</el-option
            >
            <el-option label="无部门" value=""></el-option>
          </el-select>
          <el-button style="margin-left: 10px" type="primary" @click="selAll"
            >全选</el-button
          >
          <el-button type="success" @click="reset">重置</el-button>
        </div>
        <!-- 本来这个tree在dialog上 是不用单独控制它的显示和隐藏的 不过为了让每次它的出现都刷新数据，所以这里用了v-if -->
        <el-tree
          style="display: flex; flex-direction: row; flex-wrap: wrap"
          v-if="welVisible"
          :data="mates"
          ref="mates"
          show-checkbox
          node-key="userId"
          :render-content="itemRender"
          :indent="0"
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          :props="defaultProps"
        ></el-tree>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 10px;
          "
        >
          <span style="width: 20%">福利金额(元)</span>
          <div style="width: 80%">
            <el-input
              v-model.number="currentMoney"
              placeholder="请输入福利金额"
              type="number"
            ></el-input>
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 10px;
          "
        >
          <span style="width: 20%">备注</span>
          <div style="width: 80%">
            <el-input
              type="textarea"
              v-model="currentTip"
              placeholder="请输入备注"
            ></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="welVisible = false">取 消</el-button>
        <el-button type="primary" @click="getSelMates">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMatesByCompanyId, welfareById } from '@/api/welfare'
import { getDepartment } from '@/api/department'
import bus from '@/utils/bus'
export default {
  data () {
    return {
      money: 0,
      mates: [], // 最开始的所有员工
      selMates: [], // 再组件上已选择的mate
      submitMates: [], // 提交的时候需要用的mate 是一个二维数组
      searchStr: '',
      companyId: '',
      ensureVisible: false,
      loading: false,
      welVisible: false,
      currentMoney: '',
      currentTip: '',
      defaultProps: {
        children: 'children',
        label: 'realname'
      },
      value: '全部部门',
      options: [],
      page: 1,
      pageSize: 10
    }
  },
  computed: {
    /* 计算人员 */
    matesCount: function () {
      let mates = []
      this.submitMates.forEach(arr => {
        mates = mates.concat(arr)
      })
      return mates.length
    },
    /* 计算金钱 */
    allMoney: function () {
      let money = 0
      console.log(this.submitMates)
      this.submitMates.forEach(arr => {
        // console.log(arr);
        arr.forEach(e => {
          if (e.amount == '') {
            e.amount = 0
          }
          money += parseFloat(e.amount)
        })
      })
      return money.toFixed(2)
    }
  },
  mounted () {
    let arrs = JSON.parse(localStorage.getItem('arr'))
    if (arrs) {
      this.submitMates.push(arrs)
      localStorage.removeItem('arr')
    }
    this.companyId = localStorage.companyId
    this.getMates()
    bus.$on('changeCompany', id => {
      console.log(id)
      this.mates = []
      this.selMates = []
      this.companyId = id
      this.getMates()
    })
    let data = { companyId: this.companyId }
    getDepartment(data).then(res => {
      this.options = res
    })
  },
  destroyed () {
    bus.$off('changeCompany')
  },
  watch: {
    /* 监听搜索过滤 */
    searchStr: function (val) {
      this.$refs.mates.filter(val)
    }
  },
  methods: {
    /* tree组建的itme布局的渲染 */
    itemRender (h, { node, data, store }) {
      return h(
        'div',
        {
          style: `min-width:60px;${node.disabled ? 'pointer-events: none;' : ''};position:relative`, // 这个目前有没有生效待定
          on: {
            click: () => {
              if (!node.disabled) {
                node.checked = !node.checked
              }
            }
          }
        },
        [
          h('span', {
            class: 'realname'
          }, data.realname),

          h('span', {
            style: {
              position: 'absolute',
              padding: '3px',
              background: '#fff',
              border: '1px solid #ddd',
              top: '-25px',
              left: '-20px',
              zIndex: '1000',
              display: 'none'
            },
            class: 'abc'
          }, (data.deptName ? data.deptName : '无部门') + ':' + data.phone)
        ]
        // data.realname
      )
    },
    /* 搜索 */
    filterNode (value, data) {
      if (!value) return true
      return data.realname.indexOf(value) !== -1
    },
    /* 点击事件 */
    handleCheckChange (data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
      // this.getSelMates()
    },

    selAll () {
      this.$refs.mates.setCheckedNodes(this.mates)
      // this.getSelMates()
    },
    reset () {
      console.log('reset')
      this.$refs.mates.setCheckedNodes([])
      // this.getSelMates()
    },

    getSelMates () {
      if (this.currentMoney <= 0) {
        this.$message('请输入正确的福利金额')
        return
      }

      this.selMates = this.$refs.mates.getCheckedNodes()// element提供的方法，获的tree上所有选中的节点
      if (this.selMates.length <= 0) {
        this.$message('请选择人员')
        return
      }
      this.welVisible = false

      let mates = []
      this.selMates.forEach(e => {
        if (!e.disabled) {
          e.amount = parseFloat(Math.abs(this.currentMoney)).toFixed(2)
          e.desc = this.currentTip
          e.disabled = true
          mates.push(e)
        }
      })
      this.submitMates.push(mates)
      this.currentMoney = ''
      this.currentTip = ''
      // this.submitMates.concat(this.selMates);
      // this.reset()
    },
    /*
      移除某一个员工,是在submitMates这个二维数组里的某一个数组进行操作
      所以这个方法会传递两个值，一个是要移除的对象，一个是submitMates的索引
     */
    removeMate (obj, index) {
      let tempArr = this.submitMates[index]
      tempArr = tempArr.filter(e => e.userId !== obj.userId)
      if (tempArr.length <= 0) {
        this.$delete(this.submitMates, index)
      } else {
        this.$set(this.submitMates, index, tempArr)
      }
      this.selMates.forEach(e => {
        if (e.userId === obj.userId) {
          e.disabled = false
        }
      })
      // this.submitMates[index] = tempArr;
    },
    getMates () {
      let data = {
        id: this.companyId
      }
      console.log(data)
      getMatesByCompanyId(data).then(res => {
        console.log(res)
        this.mates = res.data
        console.log(this.mates)
      })
    },
    walfareClick () {
      this.loading = true
      this.ensureVisible = false
      let mates = []
      this.submitMates.forEach(arr => {
        mates = mates.concat(arr)
      })
      let data = {
        companyId: this.companyId,
        users: mates,
        orderId: 0
      }
      welfareById(data).then(res => {
        console.log(res)
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '已提交福利发放申请'
          })
          this.currentMoney = ''
          this.currentTip = ''
          this.submitMates = []
          this.selMates = []
          this.$router.replace('/welfarelist')
        } else {
          this.$message(res.msg)
        }
      })
    },
    searchList (val) {
      this.deptId = val
      if (val == '全部部门') {
        let data = {
          id: this.companyId
        }
        this.getMates()
      } else {
        if (val == 0) {
          this.deptId = 0
        } else {
          this.deptId = val
        }
        let data = {
          id: this.companyId,
          deptId: this.deptId
        }
        console.log(data)
        getMatesByCompanyId(data).then(res => {
          console.log(res)
          this.mates = res.data
        })
      }
    }
  },
  filters: {
    number: function (val) {
      val = val.toString().replace(/\$|\,/g, '')
      if (isNaN(val)) {
        val = '0'
      }
      let sign = (val == (val = Math.abs(val)))
      val = Math.floor(val * 100 + 0.50000000001)
      let cents = val % 100
      val = Math.floor(val / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
        val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3))
      }
      return (((sign) ? '' : '-') + val + '.' + cents)
    }
  }
}
</script>

<style lang="scss" scoped>
.welfare-main {
  .top-menu {
    width: 100%;
    margin: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .name-value {
      font-size: 16px;
      color: #526069;
      margin-right: 20px;
      > span {
        color: #f30;
      }
    }
  }
  .welfare-bottom {
    .wel-item {
      width: 100%;
      height: auto;
      margin-bottom: 20px;
      background: #fff;
      .tip {
        font-size: 12px;
        color: #333;
        margin: 15px 15px 0 0;
      }
    }
    .head-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      .mate {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 118px;
        height: 48px;
        background: #f6f6f6;
        border-radius: 4px;
        position: relative;
        margin: 0 10px 10px 0;
        > i {
          position: absolute;
          right: -2px;
          top: -2px;
          color: #f00;
          cursor: pointer;
        }
        .newAdd {
          width: 15px;
          height: 15px;
          font-size: 12px;
          line-height: 15px;
          text-align: center;
          position: absolute;
          left: 0px;
          top: 0px;
          z-index: 1;
          color: #f00;
        }
        .d4 {
          position: absolute;
          left: -16px;
          top: -16px;
          width: 0;
          height: 0;
          transform: rotate(45deg);
          border-width: 16px;
          border-style: solid;
          border-color: transparent rgb(248, 244, 4) transparent transparent;
        }
        .name-money {
          height: 36px;

          .name {
            font-size: 12px;
            line-height: 18px;
            color: #333;
          }
          .money {
            font-size: 12px;
            line-height: 18px;
            color: #f30;
          }
        }

        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 18px;
          background: #67c23a;
          max-width: 100px;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          color: #fff;
          margin: 0 10px;
        }
      }
    }
    .empty-view {
      margin-top: 100px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      > img {
        width: 214px;
        height: 214px;
      }
      > p {
        color: #7d8893;
        font-size: 16px;
      }
    }
  }
  .name-input {
    display: flex;
  }
}

::v-deep  .realname:hover + .abc {
  display: block !important;
}
</style>
